module.exports = "<mat-dialog-content class=\"dialog_view_cv\">\n  <div class=\"col-md-12 text-right btn_close\">\n    <span class=\"subtitle\" mat-dialog-close style=\"cursor:pointer;\" (click)=\"dialogRef.close('yes')\">Cerrar <b>X</b></span>\n  </div>\n\n  <app-cv [userId]=\"userId\" ></app-cv>\n</mat-dialog-content>\n"


//////////////////
// WEBPACK FOOTER
// /Users/everis/code/Dj/front.staff/src/app/view-cv/view-cv.component.html
// module id = ../../../../../src/app/view-cv/view-cv.component.html
// module chunks = main